// Configuration de l'API
// Production : staff.best-events.fr (frontend) → api.staff.best-events.fr (backend)
// Développement : localhost:3000 (frontend) → localhost:3001 (backend)
// Sandbox : détection automatique via le hostname

const getApiUrl = () => {
  const hostname = window.location.hostname;
  
  // Mode développement local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3001/api';
  }
  
  // Mode production (staff.best-events.fr)
  if (hostname === 'staff.best-events.fr') {
    return 'https://api.staff.best-events.fr/api';
  }
  
  // Mode sandbox (novita.ai) - détection automatique du port
  if (hostname.includes('sandbox.novita.ai')) {
    return `https://3001-${hostname.split('-').slice(1).join('-')}/api`;
  }
  
  // Fallback : même origine avec /api
  return `${window.location.origin}/api`;
};

export const API_URL = getApiUrl();
